/** Template album narrative helpers (#1608 — collapse long review sections). */

export function extractMarkdownSection(markdown, sectionName) {
  const v = String(markdown || '');
  const escaped = sectionName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(`^##\\s*${escaped}\\s*\\n([\\s\\S]*?)(?=^##\\s|$)`, 'im');
  const m = v.match(re);
  return m ? m[1].trim() : '';
}

/** Plain-text teaser for collapsed template bios (Overview first, then Reception). */
export function templateBioCollapsedTeaser(markdown) {
  const overview = extractMarkdownSection(markdown, 'Overview');
  if (overview) return overview;
  const reception = extractMarkdownSection(markdown, 'Reception');
  if (reception) return reception;
  const stripped = String(markdown || '')
    .replace(/^##\s+[^\n]+\n?/gm, '')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\[\[([^\]]+)\]\]/g, '$1')
    .trim();
  return stripped.slice(0, 480);
}

export function templateBioTeaserLongEnough(teaser) {
  const t = String(teaser || '').trim();
  return t.length > 220;
}
